import config from 'config'

/**
 * AnchorLink :
 *   アンカーリンクのスムーススクロール
 */

import SmoothScroll from "smooth-scroll"
import { EventEmitter } from 'events'

class AnchorLink extends EventEmitter {

  constructor() {
    super()

    this.body = document.querySelector('body')
    this.anchorLink = document.querySelectorAll('a[href^="#"]')
    this.bodyClasses = this.body.classList.value
  }

  init() {
    if (!this.anchorLink) return
    this.attachEvent()
  }

  attachEvent() {
    // const scroll = new SmoothScroll(this.anchorLink, {offset: 145})
    [...this.anchorLink].forEach(elem => {
      const scroll = new SmoothScroll();
      elem.addEventListener('click', event => {
        let offset = 0
        let anchor = null

        // a>spanをクリックしてしまった時対策
        if (event.target.tagName !== 'A') {
          anchor = document.querySelector(event.target.closest('a').getAttribute('href'))
        } else {
          anchor = document.querySelector(event.target.getAttribute('href'))
        }

        // オフセットをページ別に設定
        if (/-photoGallery|-officeGallery/.test(this.bodyClasses)) {
          offset = config.isSP ? 80 : 40
        }

        scroll.animateScroll(anchor, false, {
          offset: offset,
          speed: 1000,
          easing: 'easeOutQuart'
        })
      }, false)
    });

    document.addEventListener('scrollStart', (ev) => this.emit(ev.type), false)
    document.addEventListener('scrollStop', (ev) => this.emit(ev.type), false)
  }
}

export default AnchorLink



// WEBPACK FOOTER //
// ./src/script/modules/AnchorLink.js